export function serverLogsErrorMessage(value: unknown) {
  if (value && typeof value === "object" && "status" in value) {
    const status = (value as { status?: unknown }).status;
    if (status === 401)
      return "Your session has expired. Sign in again to view server logs.";
    if (status === 413)
      return "Log results are too large. Narrow the search or request fewer lines.";
    if (status === 403)
      return "You do not have permission to view server logs.";
  }
  return "Server logs could not be loaded.";
}
